import { Text, RangeSlider } from '@mantine/core'
import React, { useEffect, useState } from 'react'
import { useRange } from 'react-instantsearch'
import { Box, Flex } from 'components/Layout'
import { FONT_SIZE } from 'Theme'
import { FilterCollapsibleItem } from './FilterCollapsibleItem'

type FilterCollapsibleRangeProps = {
  title: string
  defaultOpened?: boolean
  attribute: string
  suffix?: string
}

const formatUtc = (timestamp: number) => {
  const date = new Date(timestamp * 1000)
  return date.toLocaleString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
}

export const FilterCollapsibleTimeRange = ({
  title,
  defaultOpened,
  attribute,
  suffix,
}: FilterCollapsibleRangeProps) => {
  const { start, range, canRefine, refine } = useRange({ attribute })
  const { min, max } = range

  const from = Math.max(min, Number.isFinite(start[0]) ? start[0] : min)
  const to = Math.min(max, Number.isFinite(start[1]) ? start[1] : max)

  const [value, setValue] = useState<[number, number]>([from, to])

  useEffect(() => {
    setValue([from, to])
  }, [from, to])

  if (!canRefine) {
    return null
  }

  return (
    <FilterCollapsibleItem title={title} defaultOpened={defaultOpened}>
      <Box>
        <Flex justifyContent="space-between" mb={2}>
          <Text style={{ fontSize: FONT_SIZE.PX_14 }}>
            {formatUtc(min)}
            {suffix}
          </Text>
          <Text style={{ fontSize: FONT_SIZE.PX_14 }}>
            {formatUtc(max)}
            {suffix}
          </Text>
        </Flex>

        <RangeSlider
          label={null}
          min={min}
          max={max}
          value={value}
          onChange={setValue}
          onChangeEnd={refine}
          disabled={!canRefine}
          step={1}
          minRange={0}
        />
      </Box>
    </FilterCollapsibleItem>
  )
}
